module.exports = __webpack_public_path__ + "img/gwyx-sxjxyxfc.330e63f5.png";